/**
 * @file: 横杆渲染状态切换
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../../UIToolkit/index';

export function statusSwitch(cube: CubeNode): void {
    let $textEl: JQuery<HTMLElement> = cube.jView.find('.beam-tags');

    if ((UIToolkit.isTxTModel() || UIToolkit.isColorModel())
        && UIToolkit.tagIsChecked()) {
        // 显示
        $textEl
            .removeClass('hide')
            .addClass('show');
        return;
    }

    // 隐藏
    $textEl
        .removeClass('show')
        .addClass('hide');
}
